import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { getDepositNetworksByCurrencyApi } from '@flipster/apis/v1/wallet';
import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';

import { walletModalBunja } from '../shared/core/state';

export const depositModalBunja = bunja(() => {
  const { networkItemsAtom, selectedCurrencyAtom, selectedCurrencyItemAtom, selectedNetworkAtom } =
    bunja.use(walletModalBunja);

  const depositNetworksBaseAtom = atomWithQuery((get) => {
    const selectedCurrency = get(selectedCurrencyAtom);
    return {
      queryKey: ['getDepositNetworksByCurrencyApi', selectedCurrency],
      queryFn: () => getDepositNetworksByCurrencyApi(selectedCurrency ?? ''),
      enabled: !!selectedCurrency,
    };
  });
  const depositNetworksAtom = atom((get) => get(depositNetworksBaseAtom).data?.data.networks ?? []);
  const selectedBlockchainNameAtom = atom((get) => {
    return get(networkItemsAtom).find((item) => item.value === get(selectedNetworkAtom))?.blockchainName;
  });
  const currencyDepositNetworkAtom = atom((get) => {
    const depositNetworks = get(depositNetworksAtom);
    const selectedBlockchainName = get(selectedBlockchainNameAtom);
    return depositNetworks.find((dn) => dn.blockchainName.toLowerCase() === selectedBlockchainName?.toLowerCase());
  });

  const isCongestedAtom = atom((get) => get(currencyDepositNetworkAtom)?.isCongested);
  const estTimeMinAtom = atom((get) => get(currencyDepositNetworkAtom)?.estTimeMin);

  const networkItemsWithStatusAtom = atom((get) => {
    const depositNetworks = get(depositNetworksAtom);
    const items = get(networkItemsAtom);
    return items.map((item) => {
      const targetDepositNetwork = depositNetworks.find(
        (dn) => dn.blockchainName.toLowerCase() === item.blockchainName.toLowerCase(),
      );
      const networkLabel = (() => {
        if (targetDepositNetwork && !targetDepositNetwork?.estTimeMin) {
          return (
            <div>
              <p className={selectLabelStyle}>{item.value}</p>
              <p className={descStyle}>
                <FormattedMessage id='Deposit.r250401.May_be_delayed' />
              </p>
            </div>
          );
        }
        if (targetDepositNetwork?.isCongested && targetDepositNetwork?.estTimeMin) {
          return (
            <div>
              <p className={selectLabelStyle}>{item.value}</p>
              <p className={descStyle}>
                <FormattedMessage id='Deposit.r250401.Congested' /> (
                <FormattedMessage
                  id='Deposit.r250401.Est_time_minute_mins'
                  values={{ minute: targetDepositNetwork.estTimeMin }}
                />
                )
              </p>
            </div>
          );
        }
        return item.label;
      })();

      return {
        label: networkLabel,
        value: item.value,
        selectedLabel: item.label,
      };
    });
  });

  return {
    currencyDepositNetworkAtom,
    isCongestedAtom,
    estTimeMinAtom,
    networkItemsAtom,
    networkItemsWithStatusAtom,
    selectedCurrencyAtom,
    selectedCurrencyItemAtom,
    selectedNetworkAtom,
    selectedBlockchainNameAtom,
  };
});
depositModalBunja.debugLabel = 'depositModalBunja';

const selectLabelStyle = css({ textStyle: 'Text/L/Strong', textAlign: 'left' });
const descStyle = css({ textStyle: 'Text/S/Regular', mt: 4, color: 'content.default.level-1' });
